import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./figma.css";
import "./framer.css";
import "inter-ui/inter.css";
import { store } from "./data/redux/store";
import { Provider } from "react-redux";
import Router from "./views/Router";
import { ConfigProvider } from "antd";

const root = createRoot(document.getElementById("root") as HTMLElement);

function cssVar(name: string): string {
  return getComputedStyle(document.documentElement).getPropertyValue(name);
}

root.render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: cssVar("--active"),
        },
        components: {
          Button: {
            defaultShadow: "0px 5px 5px rgba(0, 0, 0, 0.2)",
            defaultBorderColor: cssVar("--active"),
          },
        },
      }}
    >
      <Provider store={store}>
        <Router />
      </Provider>
    </ConfigProvider>
  </React.StrictMode>,
);
